import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Formik } from 'formik';
import * as Yup from 'yup';

// Data
import { LoginFormContainerProps, LoginFormFields } from './login-form.interfaces';
import { AuthApiService } from '../../../lib/utils/auth-api.service';
import { isValidEmail } from '../../../lib/helpers/validation.helpers';
import { buildSetAuthUser } from '../../../lib/services/auth.service';
import { SessionType } from '../../../lib/types/session.types';
import { readStaffNextPath, staffPostLoginPath } from '../../../lib/helpers/next-path.helpers';

// Components
import { LoginForm } from './login-form.component';

export const LoginFormContainer: React.FC<LoginFormContainerProps> = ({ token }) => {
  const history = useHistory();
  const { search } = useLocation();
  const [submitError, setSubmitError] = useState<string | null>();
  const onSetAuthUser = buildSetAuthUser();

  // Where an emailed deep link was headed before the login bounce, if anywhere.
  const nextPath = readStaffNextPath(search);

  // Auto sign in if we have a token...
  if (token) {
    AuthApiService.authenticateWithToken({ token })
      .then((nextUser: IUser) => {
        return onSetAuthUser(nextUser, SessionType.STAFF, nextPath ?? undefined)
      })
  }

  async function handleSubmit(values: LoginFormFields, { setSubmitting }: any) {
    setSubmitError(null);
    try {
      const nextUser = await AuthApiService.authenticate(values);

      await onSetAuthUser(nextUser, SessionType.STAFF);
      history.push(staffPostLoginPath(search));
    } catch (err) {
      setSubmitError(err.message);
    }

    setSubmitting(false);
  }

  const INITIAL_FORM_VALUES = { email: '', password: '' };


  const validationSchema = Yup.object().shape({
    email: Yup.string().test('valid-email', 'Enter a valid email address', isValidEmail),
    password: Yup.string().required('Password is required')
  });

  return (
    <Formik
      initialValues={INITIAL_FORM_VALUES}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {form => <LoginForm form={form} submitError={submitError ?? undefined} />}
    </Formik>
  );
}
